import { CircularProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';

const DataTable = ({
    tableCols,
    tableData,
    itemsCount,
    title,
    searchField,
    searchTitle,
    searchHandler,
    children,
    isLoading
}) => {
    const [initData, setInitData] = useState(tableData);
    const [shownData, setShownData] = useState([]);
    const [pagesCount, setPagesCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsCnt, setItemsCnt] = useState((itemsCount >= 1 && itemsCount <= 20) ? itemsCount : 10);
    const [searchChar, setSearchChar] = useState("");

    const handleSetCurrentPage = (ev, page) => {
        setCurrentPage(page);
    }

    const handleSetItemsCnt = (ev) => {
        const cnt = parseInt(ev.target.value);
        if (Number.isNaN(cnt)) {
            return setItemsCnt(10);
        } else if (cnt > 20) {
            return setItemsCnt(20);
        } else if (cnt < 1) {
            return setItemsCnt(1);
        }
        setItemsCnt(cnt);
    }

    const handleSetSearchChar = (ev) => {
        const char = ev.target.value;
        setSearchChar(char);
        const data = tableData.filter((d) => {
            return d[searchField].toString().toLowerCase().includes(char.trim().toLowerCase());
        });
        setInitData(data);
    }

    useEffect(() => {
        setInitData(tableData);
    }, [tableData]);

    useEffect(() => {
        const pagesCnt = Math.ceil(initData.length / itemsCnt);
        setPagesCount(pagesCnt);
        if (currentPage > pagesCnt) {
            setCurrentPage(1);
        }
    }, [itemsCnt, initData]);

    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsCnt;
        const endIndex = currentPage * itemsCnt;
        const data = initData.slice(startIndex, endIndex);
        setShownData(data);
    }, [itemsCnt, currentPage, initData]);

    return isLoading ? (
        <div className="flex flex-col 
        items-center justify-center
        py-8">
            <CircularProgress size={50} />
            <span className="text-primary mt-4 
            text-xl opacity-animation">
                صبر کنید...
            </span>
        </div>
    ) : (
        <>
            <h1 className="ms-1 text-2xl text-center mb-4">
                {title}
            </h1>
            {children && (
                <div className="mb-4 flex justify-between items-center flex-wrap">
                    {children}
                </div>
            )}
            <div className="flex justify-between items-center 
            flex-wrap mb-5">
                <input type="text"
                    className="border-2 rounded-md 
                    outline-none w-72 px-2 py-1 mb-2 me-2"
                    placeholder={`جست و جو ${searchTitle ? `(${searchTitle})` : ""}`}
                    value={searchChar}
                    onChange={
                        searchHandler ?
                            (ev) => searchHandler(ev, tableData, setSearchChar, setInitData) :
                            (ev) => handleSetSearchChar(ev)
                    }
                />
                <Tooltip
                    title="تعداد سطرهای جدول (1 تا 20)"
                    arrow={true}
                    placement="bottom"
                >
                    <input type="number"
                        className="border-2 rounded-md 
                        outline-none w-52 px-2 py-1 mb-2"
                        // min="1" max="20"
                        // value={itemsCnt}
                        placeholder="تعداد سطرها"
                        onChange={(ev) => handleSetItemsCnt(ev)}
                    />
                </Tooltip>
            </div>
            <TableContainer component={Paper}
                sx={{
                    overflowX: "auto",
                    mb: 4,
                    borderRadius: "10px"
                }}
                elevation={5}
            >
                {initData.length > 0 ? (
                    <Table sx={{ minWidth: "600px" }}>
                        <TableHead className="border-b-2 border-black">
                            <TableRow>
                                {tableCols.map((col, index) => (
                                    <TableCell
                                        key={`${Math.random()}_${index}`}
                                        align="center"
                                    >
                                        {col.text}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {shownData.map((data, index) => (
                                <TableRow
                                    key={`${Math.random()}_${index}`}
                                    className="[&:nth-child(2n+1)]:bg-gray-100"
                                >
                                    {tableCols.map((col, index) => (
                                        <TableCell
                                            key={`${Math.random()}_${index}`}
                                            align="center"
                                        >
                                            {col.field ? data[col.field] : col.element(data)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <div className="w-full px-3 py-10 text-center text-red-500 text-xl">
                        هیچ نتیجه ای یافت نشد!
                    </div>
                )}
            </TableContainer>
            {pagesCount > 1 && (
                <div className="children-dir-ltr mt-8 w-full
                  flex justify-center items-center">
                    <Pagination
                        count={pagesCount}
                        page={currentPage}
                        boundaryCount={1}
                        onChange={(ev, page) => handleSetCurrentPage(ev, page)}
                        color="primary"
                    />
                </div>
            )}
        </>
    );
}

export default DataTable;
